import { render } from "./points.vue?vue&type=template&id=5a8bd92e&scoped=true"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"

import "./points.vue?vue&type=style&index=0&id=5a8bd92e&lang=scss"
import "./points.vue?vue&type=style&index=1&id=5a8bd92e&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8bd92e"]])

export default __exports__